import InitiativeBox from './InitiativeBox';

export default InitiativeBox;
export { InitiativeBox };
